AOS.init();

$(document).ready(function () {
    $(window).scroll(function () {
        if ($(window).scrollTop() >= 10) {
            $('.navbar').addClass('header-fixed');
        }
        else {
            $('.navbar').removeClass('header-fixed');
        }
    });
});

$('.banner-slider').owlCarousel({
    loop: false,
    margin: 5,
    nav: true,
    dots: false,
    autoplay: false,
    navText: ['<i class="fa-solid fa-angle-left"></i>', '<i class="fa-solid fa-angle-right"></i>'],
    //autoplayTimeout: 5000,
    // autoplaySpeed: 3000,
    //autoplay: true,
    smartSpeed: 3000,
    // animateOut: 'pulseOut',
    // animateIn: 'pulseIn',
    autoplayHoverPause: false,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        767: {
            items: 1,
        },
        992: {
            items: 1,
        },
        1200: {
            items: 1,
        }
    }
});

$('.pro-slider').owlCarousel({
    loop: true,
    center: true,
    margin: 12,
    nav: false,
    dots: true,
    autoplay: false,
    smartSpeed: 3000,
    autoplayHoverPause: true,
    responsiveClass: true,
    responsive: {
        0: {
            items: 1,
        },
        767: {
            items: 3,
        },
        992: {
            items: 5,
        },
        1200: {
            items: 5,
        }
    }
});

/* search.js
 ========================================================*/
var searchToggle = $('.open-search'),
    inputAnime = $(".form-search"),
    body = $('body');

searchToggle.on('click', function (event) {
    event.preventDefault();

    if (!inputAnime.hasClass('active')) {
        inputAnime.addClass('active');
    } else {
        inputAnime.removeClass('active');
    }
});

body.on('click', function () {
    inputAnime.removeClass('active');
});

var elemBinds = $('.open-search, .form-search');
elemBinds.bind('click', function (e) {
    e.stopPropagation();
});

/* End search.js
========================================================*/

$(document).ready(function () {
    $('.auto-size').isotope({
        itemSelector: '.masonry-item',
        layoutMode: 'masonry'
    });
});